/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Session_Hard_Limit_HardInputs */

const en_us2_onboarding_session_hard_limit_hard = /** @type {(inputs: Onboarding_Session_Hard_Limit_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a hard limit`)
};

const pt_br2_onboarding_session_hard_limit_hard = /** @type {(inputs: Onboarding_Session_Hard_Limit_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um limite rígido`)
};

const es_419_onboarding_session_hard_limit_hard = /** @type {(inputs: Onboarding_Session_Hard_Limit_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es un límite estricto`)
};

const pt_pt2_onboarding_session_hard_limit_hard = /** @type {(inputs: Onboarding_Session_Hard_Limit_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um limite rígido`)
};

const fr_fr2_onboarding_session_hard_limit_hard = /** @type {(inputs: Onboarding_Session_Hard_Limit_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est une limite stricte`)
};

const de_de2_onboarding_session_hard_limit_hard = /** @type {(inputs: Onboarding_Session_Hard_Limit_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine feste Grenze`)
};

const it_it2_onboarding_session_hard_limit_hard = /** @type {(inputs: Onboarding_Session_Hard_Limit_HardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È un limite rigido`)
};

/**
* | output |
* | --- |
* | "It is a hard limit" |
*
* @param {Onboarding_Session_Hard_Limit_HardInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_session_hard_limit_hard = /** @type {((inputs?: Onboarding_Session_Hard_Limit_HardInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Session_Hard_Limit_HardInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_session_hard_limit_hard(inputs)
	if (locale === "es-419") return es_419_onboarding_session_hard_limit_hard(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_session_hard_limit_hard(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_session_hard_limit_hard(inputs)
	if (locale === "de-DE") return de_de2_onboarding_session_hard_limit_hard(inputs)
	if (locale === "it-IT") return it_it2_onboarding_session_hard_limit_hard(inputs)
	return en_us2_onboarding_session_hard_limit_hard(inputs)
});
export { onboarding_session_hard_limit_hard as "onboarding.session_hard_limit.hard" }